module.exports = __webpack_public_path__ + "static/media/tag@3x-ticket-mtn.aeeb865b.png";